import jsPDF from 'jspdf';
import 'jspdf-autotable';

const patientVitalsToPDF = ({ inputPDF, patient }) => new Promise((resolve) => {
  const lineHeight = 1.2;
  const margin = 10;
  const ptsPerMm = 2.834646;
  const fontSize = 10;
  const titleFontSize = 18;
  const fontType = 'normal';
  const textColor = 0;
  const drawColor = 0;
  const lineHeightMm = fontSize * (lineHeight / ptsPerMm);
  const format = 'a4';
  // eslint-disable-next-line new-cap
  const doc = inputPDF || new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format,
    lineHeight,
  });
  if (inputPDF) {
    doc.addPage(format);
  }
  doc.setFont('times');
  let y = margin;
  let x = margin;
  const pageContentWidth = doc.internal.pageSize.getWidth() - (margin * 2);
  let maxWidth = pageContentWidth;
  const setDefaults = () => {
    doc.setFontSize(fontSize);
    doc.setFontType(fontType);
    doc.setTextColor(textColor);
    doc.setDrawColor(drawColor);
  };
  const addY = (newY) => {
    if ((y + newY) < doc.internal.pageSize.getHeight() - (margin * 2)) {
      y += newY;
    } else {
      doc.addPage();
      y = margin;
    }
  };
  const renderTitle = () => {
    doc.setFontSize(titleFontSize);
    doc.setFontType('bold');
    x = (doc.internal.pageSize.getWidth() / 2);
    maxWidth = pageContentWidth * 0.75;
    const text = doc.splitTextToSize(`${patient['Last Name']}, ${patient['First Name']} Vitals`, maxWidth);
    text.forEach((line) => {
      addY(titleFontSize * (lineHeight / ptsPerMm));
      doc.text(line, x, y, null, null, 'center');
    });
    addY(margin / 2);
  };
  const renderPatientVitals = () => {
    setDefaults();
    addY(lineHeightMm);
    x = margin;
    maxWidth = pageContentWidth;
    if (patient.Vitals.length > 0) {
      const columns = ['Weight', 'Height', 'BMI', 'Date'];
      const rows = patient.Vitals.map(item => ([
        `${item.Weight} lb`,
        `${item['Height Ft']}ft, ${item['Height In']}in`,
        `${item.BMI}`,
        item['Create At'],
      ]));
      doc.autoTable(columns, rows, {
        theme: 'grid',
        startY: y,
        showHeader: 'everyPage',
        margin: [0, 0, 0, x],
        tableWidth: maxWidth,
        styles: {
          font: 'times',
          textColor,
          lineColor: drawColor,
          fontSize,
          cellPadding: [0, margin / 4, 0, margin / 4],
          columnWidth: 'auto',
          overflow: 'linebreak',
        },
        headerStyles: {
          lineWidth: 0.1,
          lineColor: drawColor,
          fillColor: 'white',
        },
      });
      const table = doc.autoTable.previous;
      addY((table.finalY - y) + margin);
    } else {
      doc.text('Patient has no vitals', x, y);
      addY(margin);
    }
  };

  renderTitle();
  renderPatientVitals();
  resolve(doc);
});

export default patientVitalsToPDF;



// WEBPACK FOOTER //
// ./src/utils/patientVitalsToPDF.js